/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Addons_SubtitleInputs */

const tr_pricing_addons_subtitle = /** @type {(inputs: Pricing_Addons_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI kredileriniz bittiğinde panelden ek paket talebi gönderebilirsiniz. Talebinizi alırız; bu işlem satın alma değildir.`)
};

const en_pricing_addons_subtitle = /** @type {(inputs: Pricing_Addons_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When your AI credits run out, you can request an extra pack from the panel. We receive your request; this does not make a purchase.`)
};

const de_pricing_addons_subtitle = /** @type {(inputs: Pricing_Addons_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Ihre Credits aufgebraucht sind, können Sie im Panel ein zusätzliches Paket anfragen. Wir nehmen die Anfrage auf; dadurch erfolgt kein Kauf.`)
};

const ru_pricing_addons_subtitle = /** @type {(inputs: Pricing_Addons_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда ИИ-кредиты закончатся, можно отправить запрос на дополнительный пакет из панели. Мы получим запрос; покупка при этом не совершается.`)
};

/**
* | output |
* | --- |
* | "When your AI credits run out, you can request an extra pack from the panel. We receive your request; this does not make a purchase." |
*
* @param {Pricing_Addons_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_addons_subtitle = /** @type {((inputs?: Pricing_Addons_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Addons_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_addons_subtitle(inputs)
	if (locale === "de") return de_pricing_addons_subtitle(inputs)
	if (locale === "ru") return ru_pricing_addons_subtitle(inputs)
	return tr_pricing_addons_subtitle(inputs)
});